import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiCareerSite, ApiCareerSitePayload } from "@/types/recruit/career-site.types.ts";

export const apiCareerSite = {
  getAll: async function () {
    return api.get<ApiCareerSite[]>(`/api/v1/career-site/settings`);
  },
  getById: async function (id: number) {
    return api.get<ApiCareerSite>(`/api/v1/career-site/settings/${id}`);
  },
  create: async function (payload: ApiCareerSitePayload) {
    return api.post<ApiCareerSite>(`/api/v1/career-site/settings`, payload);
  },
  update: async function (id: number, payload: ApiCareerSitePayload) {
    return api.put<ApiCareerSite>(`/api/v1/career-site/settings/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete<ApiOperationResult>(`/api/v1/career-site/settings/${id}`);
  },
};
